import React, { useEffect, useState } from "react";
import { api } from "@/auth/AuthContext";
import { useT } from "@/i18n/I18nContext";
import { PageHeader, Card } from "@/components/ui-kit";
import { Calendar as CalendarIcon, Warning } from "@phosphor-icons/react";

const Calendar = () => {
  const { t, lang } = useT();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadedAt, setLoadedAt] = useState(null);
  useEffect(() => {
    api.get("/calendar").then(r => { setItems(r.data); setLoadedAt(new Date()); }).finally(() => setLoading(false));
  }, []);
  return (
    <div>
      <PageHeader title={t("calendar.title")} sub={t("calendar.sub")} />
      <div className="p-4 sm:p-6 lg:p-8 space-y-3">
        <div className="rounded-lg border border-amber-500/25 bg-amber-500/5 p-4 flex items-start gap-3" data-testid="calendar-disclaimer">
          <Warning weight="fill" size={18} className="text-amber-500/80 flex-shrink-0 mt-0.5" />
          <div className="min-w-0">
            <p className="text-xs text-zinc-400 leading-relaxed">
              {lang === "cs" ? (
                <><strong className="text-zinc-300">Důležité upozornění:</strong> Údaje v ekonomickém kalendáři mají informativní charakter a mohou se změnit, být opožděné nebo neúplné v důsledku aktualizací zdrojů třetích stran či mimořádných fundamentálních událostí. Před obchodním rozhodnutím si prosím ověřte důležité informace také v nezávislých a aktuálních zdrojích. TradeMind AI neručí za úplnost, přesnost ani aktuálnost uvedených údajů a neposkytuje investiční doporučení.</>
              ) : (
                <><strong className="text-zinc-300">Important notice:</strong> The data in the economic calendar is for informational purposes only and may change, be delayed or incomplete due to third-party source updates or extraordinary fundamental events. Before making any trading decision, please also verify important information in independent, up-to-date sources. TradeMind AI does not guarantee the completeness, accuracy or timeliness of the data provided and does not provide investment advice.</>
              )}
            </p>
            {loadedAt && (
              <p className="text-[11px] font-mono text-zinc-500 mt-2" data-testid="calendar-last-updated">
                {lang === "cs" ? "Poslední aktualizace dat: " : "Data last updated: "}
                {loadedAt.toLocaleDateString(lang === "cs" ? "cs-CZ" : "en-US", { day: "2-digit", month: "2-digit", year: "numeric" })}, {loadedAt.toLocaleTimeString(lang === "cs" ? "cs-CZ" : "en-US", { hour: "2-digit", minute: "2-digit" })}
              </p>
            )}
          </div>
        </div>
        {loading && <div className="text-zinc-500 text-sm">Loading...</div>}
        {items.map((ev, i) => {
          const impactColor = ev.impact === "high" ? "text-red-400 border-red-500/30 bg-red-500/10" : ev.impact === "medium" ? "text-yellow-400 border-yellow-500/30 bg-yellow-500/10" : "text-zinc-400 border-zinc-700 bg-zinc-800/50";
          return (
            <Card key={i} className="p-5 hover:border-zinc-700 transition-colors" data-testid={`calendar-row-${i}`}>
              <div className="flex items-start gap-4">
                <div className="text-center flex-shrink-0 w-20">
                  <div className="text-xs font-mono uppercase tracking-wider text-zinc-500">{new Date(ev.date).toLocaleDateString(lang === "cs" ? "cs-CZ" : "en-US", { day: "2-digit", month: "short" })}</div>
                  <div className="text-base font-mono font-medium text-zinc-100 mt-0.5">{new Date(ev.date).toLocaleTimeString(lang === "cs" ? "cs-CZ" : "en-US", { hour: "2-digit", minute: "2-digit" })}</div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs font-mono uppercase tracking-wider text-zinc-500">{ev.country}</span>
                    <h4 className="text-base font-medium text-zinc-100">{ev.event}</h4>
                    <span className={`text-xs font-mono uppercase tracking-wider px-2 py-0.5 rounded border ${impactColor}`}>{t(`calendar.impact.${ev.impact}`)}</span>
                  </div>
                  <div className="flex items-center gap-4 text-xs font-mono text-zinc-400 mt-2">
                    <span>Forecast: <span className="text-zinc-200">{ev.forecast}</span></span>
                    <span>Previous: <span className="text-zinc-200">{ev.previous}</span></span>
                  </div>
                  <p className="text-sm text-blue-400 mt-2 italic">// AI: {ev.ai_note}</p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
